module.exports = __webpack_public_path__ + "files/ff16ee0a972221c24800b1e3aaba8cb4.png";